import React from 'react';
import { NextSeo } from 'next-seo';
import { GetServerSideProps } from 'next';
import { useTranslation } from 'next-i18next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { redirectToUnderConstructionPage } from '@/utils/rewrites';
import { Layout, MainLayout } from '@/components/templates';
import ContactFormSection from '@/sections/contact-form';
import CarouselSection from '@/sections/carousel';
import { NextPageWithLayout } from '@/types';
import { Section } from '@/components/molecules';
import { SkeletonGroup } from '@/components/molecules/ExperienceCardSkeleton/ExperienceCardSkeleton.styles';
import { Skeleton } from '@/components/atoms';
import DescriptionSection from '@/sections/description';
import { usePolicies } from '@/services/policies';
import { PolicyTypeEnum } from '@/graphql/types';

const ReturnPolicyPage: NextPageWithLayout = () => {
    const { t } = useTranslation(); // Translations
    const { loading, policies } = usePolicies(PolicyTypeEnum.ReturnPolicies);

    return (
        <>
            <NextSeo title={t('seo:return-policy.title')} />

            <CarouselSection section="return_policy" />

            {loading && (
                <Section container={'compacted'} bgcolor={'white'}>
                    <SkeletonGroup>
                        <Skeleton height={5} radius={20} />
                        <Skeleton height={7} radius={20} mt={1} />
                        <Skeleton height={10} radius={20} mt={1} />
                        <Skeleton height={7} radius={20} mt={1} />
                        <Skeleton height={8} radius={20} mt={1} />
                    </SkeletonGroup>
                </Section>
            )}
            {!loading && !!policies && <DescriptionSection id="return_policies" title={''} description={policies as string} alignText={'justify'} />}

            <ContactFormSection />
        </>
    );
};

ReturnPolicyPage.getLayout = (page: React.ReactElement) => {
    return (
        <Layout>
            <MainLayout>{page}</MainLayout>
        </Layout>
    );
};

export const getServerSideProps: GetServerSideProps = async (context) => {
    const rules = redirectToUnderConstructionPage();

    const translations = await serverSideTranslations(context?.locale as string, ['common', 'seo', 'carousel', 'footer', 'navigations', 'user-menu', 'newsletter', 'contact']);

    return {
        ...rules,
        props: {
            ...translations,
        },
    };
};

export default ReturnPolicyPage;
